import React from "react";
import { AgGridReact } from "ag-grid-react";

import { BaseDataTable } from "./BaseDataTable";
import { DataTableProps } from "./types/types";

/**
 * DataTable - Enterprise-grade table component built on AG Grid
 *
 * Features:
 * - Configurable presets (default, minimal)
 * - Customizable themes
 * - Full AG Grid React prop support
 * - Enterprise module support
 *
 * @example
 * ```tsx
 * <DataTable
 *   configure={{ preset: "default" }}
 *   rowData={data}
 *   columnDefs={columns}
 *   gridOptions={{ paginationPageSize: 50 }}
 * />
 * ```
 */
export const DataTable = React.forwardRef<AgGridReact, DataTableProps>(
  (props, ref) => <BaseDataTable ref={ref} {...props} />,
);

DataTable.displayName = "DataTable";
